<div class="card w-100 mt-3">
  <div class="card-body">
    <h6 class="card-title text-uppercase">Verwalter-Accounts</h6>

    <!-- Loading overlay -->
    <div class="loading-overlay" [class.visible]="isLoading">
      <div class="loading-content">
        <fa-icon [icon]="loadingIcon" size="3x" animation="spin-pulse"></fa-icon>
        <div class="mt-2">Daten werden geladen ...</div>
      </div>
    </div>

    <!-- Tabs for different sections -->
    <ul class="nav nav-tabs" id="verwalterTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="managed-accounts-tab" data-bs-toggle="tab" data-bs-target="#managed-accounts"
                type="button" role="tab" aria-controls="managed-accounts" aria-selected="true">
          Verwaltete Accounts
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="generate-pin-tab" data-bs-toggle="tab" data-bs-target="#generate-pin"
                type="button" role="tab" aria-controls="generate-pin" aria-selected="false">
          PIN generieren
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="enter-pin-tab" data-bs-toggle="tab" data-bs-target="#enter-pin"
                type="button" role="tab" aria-controls="enter-pin" aria-selected="false">
          PIN eingeben
        </button>
      </li>
    </ul>

    <div class="tab-content" id="verwalterTabsContent">
      <!-- Managed Accounts Tab -->
      <div class="tab-pane fade show active" id="managed-accounts" role="tabpanel" aria-labelledby="managed-accounts-tab">
        <div class="mt-3">
          <h5>Verwaltete Accounts</h5>
          <p>Hier sehen Sie alle Accounts, die Sie verwalten können.</p>

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Kundennummer</th>
                  <th>Name</th>
                  <th>E-Mail</th>
                  <th>Status</th>
                  <th class="text-end">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!isLoading && managedAccounts.length === 0">
                  <td colspan="5" class="text-center">Keine verwalteten Accounts vorhanden</td>
                </tr>
                <tr *ngFor="let account of managedAccounts">
                  <td>{{ account.kundennummer }}</td>
                  <td>{{ account.titel }} {{ account.vorname }} {{ account.nachname }}</td>
                  <td>{{ account.email }}</td>
                  <td>
                    <span class="badge bg-success">Aktiv</span>
                  </td>
                  <td class="text-end">
                    <button
                      class="btn btn-sm btn-outline-danger"
                      (click)="openTerminateManagedAccount(account, terminateConnectionModal)">
                      <fa-icon [icon]="deleteIcon" class="me-1"></fa-icon>
                      Verbindung auflösen
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-4">
          <h5>Verwaltende Accounts</h5>
          <p>Hier sehen Sie alle Accounts, die Ihren Account verwalten können.</p>

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Kundennummer</th>
                  <th>Name</th>
                  <th>E-Mail</th>
                  <th>Status</th>
                  <th class="text-end">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!isLoading && managerAccounts.length === 0">
                  <td colspan="5" class="text-center">Keine verwaltenden Accounts vorhanden</td>
                </tr>
                <tr *ngFor="let account of managerAccounts">
                  <td>{{ account.kundennummer }}</td>
                  <td>{{ account.titel }} {{ account.vorname }} {{ account.nachname }}</td>
                  <td>{{ account.email }}</td>
                  <td>
                    <span class="badge bg-success">Aktiv</span>
                  </td>
                  <td class="text-end">
                    <button
                      class="btn btn-sm btn-outline-danger"
                      (click)="openTerminateManagerAccount(account, terminateConnectionModal)">
                      <fa-icon [icon]="deleteIcon" class="me-1"></fa-icon>
                      Verbindung auflösen
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-4">
          <h5>Matching-PINs</h5>
          <p>Hier sehen Sie alle Matching-PINs, die Sie erstellt haben oder die mit Ihnen geteilt wurden.</p>

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>PIN</th>
                  <th>Erstellt am</th>
                  <th>Gültig bis</th>
                  <th>Status</th>
                  <th>PIN Ausgabe durch</th>
                  <th>PIN Eingabe durch</th>
                  <th class="text-end">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!isLoading && matchingPins.length === 0">
                  <td colspan="6" class="text-center">Keine Matching-PINs vorhanden</td>
                </tr>
                <tr *ngFor="let pin of matchingPins" [ngClass]="{'pin-highlight': pin.status === MatchingPinStatus.CONFIRMED_BY_MANAGER}">
                  <td>{{ pin.pin }}</td>
                  <td>{{ pin.created_at | date:'dd.MM.yyyy HH:mm' }}</td>
                  <td>{{ pin.expires_at | date:'dd.MM.yyyy HH:mm' }}</td>
                  <td>
                    <span class="badge" [ngClass]="getStatusClass(pin.status)">
                      {{ getStatusText(pin.status) }}
                    </span>
                  </td>
                  <td>
                    <ng-container *ngIf="pin.user_info; else noIssuer">
                      {{ pin.user_info.titel }} {{ pin.user_info.vorname }} {{ pin.user_info.nachname }}
                      <span class="text-muted ms-2" *ngIf="pin.user_info.kundennummer">({{ pin.user_info.kundennummer }})</span>
                      <span class="badge bg-secondary ms-2" *ngIf="isCurrentUserInfo(pin.user_info)">Aktueller Benutzer</span>
                    </ng-container>
                    <ng-template #noIssuer>-</ng-template>
                  </td>
                  <td>
                    <ng-container *ngIf="pin.manager_info; else noReceiver">
                      {{ pin.manager_info.titel }} {{ pin.manager_info.vorname }} {{ pin.manager_info.nachname }}
                      <span class="text-muted ms-2" *ngIf="pin.manager_info.kundennummer">({{ pin.manager_info.kundennummer }})</span>
                      <span class="badge bg-secondary ms-2" *ngIf="isCurrentUserInfo(pin.manager_info)">Aktueller Benutzer</span>
                    </ng-container>
                    <ng-template #noReceiver>-</ng-template>
                  </td>
                  <td class="text-end">
                    <button
                      *ngIf="canCurrentUserConfirm(pin)"
                      class="btn btn-sm btn-primary"
                      (click)="openManagerConfirmation(pin, managerConfirmModal)">
                      Freischalten
                    </button>
                    <button
                      *ngIf="canCurrentUserConfirm(pin)"
                      class="btn btn-sm btn-warning ms-2"
                      (click)="openManagerRejection(pin, managerRejectModal)">
                      Ablehnen
                    </button>
                    <button
                      *ngIf="pin.status === MatchingPinStatus.PENDING"
                      class="btn btn-sm btn-outline-danger ms-2"
                      (click)="deletePendingPin(pin)">
                      <fa-icon [icon]="deleteIcon" class="me-1"></fa-icon>
                      Löschen
                    </button>
                    <button
                      *ngIf="pin.status === MatchingPinStatus.ACTIVE"
                      class="btn btn-sm btn-outline-danger ms-2"
                      (click)="openTerminateActivePin(pin, terminateConnectionModal)">
                      <fa-icon [icon]="deleteIcon" class="me-1"></fa-icon>
                      Verbindung auflösen
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Generate PIN Tab -->
      <div class="tab-pane fade" id="generate-pin" role="tabpanel" aria-labelledby="generate-pin-tab">
        <div class="mt-3">
          <h5>PIN generieren</h5>
          <p>Generieren Sie eine PIN, um einem anderen Account zu ermöglichen Ihren Account zu verwalten.</p>

          <div *ngIf="!isPinGenerated">
            <button class="btn btn-primary" (click)="generatePin()" [disabled]="isLoading">
              PIN generieren
            </button>
          </div>

          <div *ngIf="isPinGenerated && currentPin" class="mt-3">
            <div class="alert alert-success">
              <h6>Ihre PIN wurde generiert:</h6>
              <div class="d-flex align-items-center">
                <h3 class="mb-0 me-2">{{ currentPin.pin }}</h3>
                <button class="btn btn-sm btn-outline-secondary" (click)="copyPinToClipboard()">
                  <fa-icon [icon]="copyIcon"></fa-icon>
                </button>
              </div>
              <p class="mt-2 mb-0">
                Diese PIN ist gültig bis: {{ currentPin.expires_at | date:'dd.MM.yyyy HH:mm' }}
              </p>
              <p class="mt-2 mb-0">
                Teilen Sie diese PIN mit der Person, der Sie die Rechte Ihren Account zu verwalten geben möchten.
                Diese Person muss die PIN hier im Portal eingeben.
              </p>
            </div>

            <button class="btn btn-secondary mt-3" (click)="resetPinGeneration()">
              Zurücksetzen
            </button>
          </div>
        </div>
      </div>

      <!-- Enter PIN Tab -->
      <div class="tab-pane fade" id="enter-pin" role="tabpanel" aria-labelledby="enter-pin-tab">
        <div class="mt-3">
          <h5>PIN eingeben</h5>
          <p>Geben Sie eine PIN ein, um einen Account zu verwalten.</p>

          <div *ngIf="!isPinEntered">
            <form [formGroup]="enterPinForm" (ngSubmit)="enterPin()">
              <div class="mb-3">
                <label for="pin" class="form-label">PIN</label>
                <input type="text" class="form-control" id="pin" formControlName="pin"
                       placeholder="Format: XXX-XXX-XXX">
                <div *ngIf="enterPinForm.get('pin')?.invalid && enterPinForm.get('pin')?.touched" class="text-danger">
                  <small *ngIf="enterPinForm.get('pin')?.errors?.required">PIN ist erforderlich.</small>
                  <small *ngIf="enterPinForm.get('pin')?.errors?.minlength">PIN muss mindestens 9 Zeichen lang sein.</small>
                </div>
              </div>

              <button type="submit" class="btn btn-primary" [disabled]="enterPinForm.invalid || isLoading">
                PIN eingeben
              </button>
            </form>
          </div>

          <!-- Confirmation Dialog -->
          <div *ngIf="showConfirmation && pendingConfirmation" class="mt-3">
            <div class="alert alert-info">
              <h6>Bestätigen Sie die Verbindung</h6>
              <p>
                Möchten Sie die Verbindung mit folgendem Account bestätigen?
              </p>
              <div class="card mb-3" *ngIf="getCounterpartyUser(pendingConfirmation) as counterparty">
                <div class="card-body">
                  <h6 class="card-title">Account-Informationen des Gegenübers</h6>
                  <p class="card-text">
                    <strong>Name:</strong> {{ counterparty.titel }}
                    {{ counterparty.vorname }}
                    {{ counterparty.nachname }}
                  </p>
                  <p class="card-text">
                    <strong>Kundennummer:</strong> {{ counterparty.kundennummer }}
                  </p>
                  <p class="card-text">
                    <strong>E-Mail:</strong> {{ counterparty.email }}
                  </p>
                </div>
              </div>

              <div class="d-flex">
                <button class="btn btn-success me-2" (click)="confirmMatch(true)">
                  <fa-icon [icon]="checkIcon" class="me-1"></fa-icon>
                  Bestätigen
                </button>
                <button class="btn btn-danger" (click)="confirmMatch(false)">
                  <fa-icon [icon]="timesIcon" class="me-1"></fa-icon>
                  Ablehnen
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="isPinEntered && !showConfirmation" class="mt-3">
            <div class="alert alert-success">
              <h6>PIN erfolgreich eingegeben</h6>
              <p>
                Die Verbindung wurde hergestellt. Der Account-Inhaber muss die Verbindung noch bestätigen.
              </p>
            </div>

            <button class="btn btn-secondary mt-3" (click)="resetPinEntry()">
              Zurücksetzen
            </button>
          </div>
        </div>
      </div>

      <!-- NgbModal Template: Verwalter-Freischaltung Sicherheitsabfrage -->
      <ng-template #managerConfirmModal let-modal>
        <div class="modal-header">
          <h5 class="mb-0">Freischaltung bestätigen</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
        </div>
        <div class="modal-body">
          <p class="mb-3">
            Sind Sie sicher, dass Sie die Verbindung für die folgende PIN freischalten möchten?
          </p>
          <div class="alert alert-warning mb-3" *ngIf="selectedPinForActivation as sp">
            <div class="d-flex align-items-center">
              <strong class="me-2">PIN:</strong> <span class="me-3">{{ sp.pin }}</span>
              <span class="badge" [ngClass]="getStatusClass(sp.status)">{{ getStatusText(sp.status) }}</span>
            </div>
            <div class="mt-2" *ngIf="getCounterpartyUser(sp) as counterparty">
              <strong>Benutzer:</strong>
              {{ counterparty.titel }} {{ counterparty.vorname }} {{ counterparty.nachname }}
              <span class="text-muted ms-2">({{ counterparty.kundennummer }})</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary me-2" (click)="modal.dismiss('cancel')">
            Abbrechen
          </button>
          <button class="btn btn-success" (click)="confirmManagerActivation(); modal.close('confirm')">
            <fa-icon [icon]="checkIcon" class="me-1"></fa-icon>
            Freischalten
          </button>
        </div>
      </ng-template>

      <!-- NgbModal Template: Verwalter-Freischaltung ablehnen (Warnung) -->
      <ng-template #managerRejectModal let-modal>
        <div class="modal-header">
          <h5 class="mb-0">Freischaltung ablehnen</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger">
            <strong>Achtung:</strong> Durch das Ablehnen wird diese Verbindung verworfen. Der verwaltete Zugang wird nicht freigeschaltet.
          </div>
          <div class="alert alert-warning mb-3" *ngIf="selectedPinForRejection as sp">
            <div class="d-flex align-items-center">
              <strong class="me-2">PIN:</strong> <span class="me-3">{{ sp.pin }}</span>
              <span class="badge" [ngClass]="getStatusClass(sp.status)">{{ getStatusText(sp.status) }}</span>
            </div>
            <div class="mt-2" *ngIf="getCounterpartyUser(sp) as counterparty">
              <strong>Benutzer:</strong>
              {{ counterparty.titel }} {{ counterparty.vorname }} {{ counterparty.nachname }}
              <span class="text-muted ms-2">({{ counterparty.kundennummer }})</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary me-2" (click)="modal.dismiss('cancel')">
            Abbrechen
          </button>
          <button class="btn btn-danger" (click)="confirmManagerRejection(); modal.close('reject')">
            <fa-icon [icon]="timesIcon" class="me-1"></fa-icon>
            Ablehnen
          </button>
        </div>
      </ng-template>

      <!-- NgbModal Template: Verbindung auflösen Warnung -->
      <ng-template #terminateConnectionModal let-modal>
        <div class="modal-header">
          <h5 class="mb-0">Verbindung auflösen</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="cancelTermination(modal)"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger">
            <strong>Achtung:</strong> Durch das Auflösen wird die Verbindung dauerhaft beendet. Berechtigungen gehen verloren und müssen bei Bedarf neu eingerichtet werden.
          </div>

          <div class="alert alert-warning" *ngIf="selectedPinForTermination as sp">
            <div class="d-flex align-items-center mb-2">
              <strong class="me-2">PIN:</strong> <span class="me-3">{{ sp.pin }}</span>
              <span class="badge" [ngClass]="getStatusClass(sp.status)">{{ getStatusText(sp.status) }}</span>
            </div>
            <div *ngIf="getCounterpartyUser(sp) as counterparty">
              <strong>Gegenüber:</strong>
              {{ counterparty.titel }} {{ counterparty.vorname }} {{ counterparty.nachname }}
              <span class="text-muted ms-2">({{ counterparty.kundennummer }})</span>
            </div>
          </div>

          <div class="alert alert-warning" *ngIf="selectedManagedAccountForTermination as ma">
            <div class="fw-bold">Verwalteter Account</div>
            <div>{{ ma.titel }} {{ ma.vorname }} {{ ma.nachname }} <span class="text-muted ms-2">({{ ma.kundennummer }})</span></div>
          </div>

          <div class="alert alert-warning" *ngIf="selectedManagerAccountForTermination as mg">
            <div class="fw-bold">Verwaltender Account</div>
            <div>{{ mg.titel }} {{ mg.vorname }} {{ mg.nachname }} <span class="text-muted ms-2">({{ mg.kundennummer }})</span></div>
          </div>

          <p class="mb-0">Möchten Sie die Verbindung wirklich auflösen?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" (click)="cancelTermination(modal)">Abbrechen</button>
          <button class="btn btn-danger" (click)="confirmTermination(modal)">
            <fa-icon [icon]="deleteIcon" class="me-1"></fa-icon>
            Verbindung auflösen
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
